export default __webpack_public_path__ + "static/media/Dr-Chandrashekar-BS.75f311d4.jpg";